export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = (password) => {
  // At least 8 characters
  return password && password.length >= 8;
};

export const validateRequired = (value) => {
  return value !== null && value !== undefined && value !== '';
};

export const validatePhone = (phone) => {
  const re = /^[0-9]{10}$/;
  return re.test(String(phone).replace(/[\s-()]/g, ''));
};

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input.trim().replace(/[<>]/g, '');
};